
import { home as homeEn } from './en/home';
import { common as commonEn } from './en/common';
import { solutions as solutionsEn } from './en/solutions';
import { method as methodEn } from './en/method';
import { cartas as cartasEn } from './en/cartas';
import { empresas as empresasEn } from './en/empresas';
import { conteudos as conteudosEn } from './en/conteudos';
import { sobre as sobreEn } from './en/sobre';
import { contato as contatoEn } from './en/contato';
import { diagnostico as diagnosticoEN } from './en/diagnostico';
import { privacidade as privacidadeEn } from './en/privacidade';

import { home as homePt } from './pt/home';
import { common as commonPt } from './pt/common';
import { solutions as solutionsPt } from './pt/solutions';
import { method as methodPt } from './pt/method';
import { cartas as cartasPt } from './pt/cartas';
import { empresas as empresasPt } from './pt/empresas';
import { conteudos as conteudosPt } from './pt/conteudos';
import { sobre as sobrePt } from './pt/sobre';
import { contato as contatoPt } from './pt/contato';
import { diagnostico as diagnosticoPT } from './pt/diagnostico';
import { privacidade as privacidadePt } from './pt/privacidade';

export const resources = {
  en: {
    home: homeEn,
    common: commonEn,
    solutions: solutionsEn,
    method: methodEn,
    cartas: cartasEn,
    empresas: empresasEn,
    conteudos: conteudosEn,
    sobre: sobreEn,
    contato: contatoEn,
    diagnostico: diagnosticoEN,
    privacidade: privacidadeEn,
  },
  pt: {
    home: homePt,
    common: commonPt,
    solutions: solutionsPt,
    method: methodPt,
    cartas: cartasPt,
    empresas: empresasPt,
    conteudos: conteudosPt,
    sobre: sobrePt,
    contato: contatoPt,
    diagnostico: diagnosticoPT,
    privacidade: privacidadePt,
  },
};
